export default {
    language: [{
        type: 'de',
        name: 'Deutschland'
    }
    ]
}